import Icon from '@components/common/Icon';
import { SITE_INFO } from '@lib/constants';

const LocationSection = () => {
  return (
    <section
      className="py-16 px-6"
      style={{ backgroundColor: 'var(--color-body-bg)' }}
    >
      <div className="max-w-4xl mx-auto">
        <div
          className="p-12 rounded-2xl border-2 text-center"
          style={{
            backgroundColor: 'var(--color-card-bg)',
            borderColor: 'var(--color-card-border)',
          }}
        >
          <div
            className="inline-block p-4 rounded-full mb-6"
            style={{ backgroundColor: 'var(--color-accent-1)' }}
          >
            <Icon
              name="location"
              size="2xl"
              style={{ color: 'var(--color-accent-7)' }}
            />
          </div>

          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            Location
          </h2>
          <p
            className="text-2xl font-semibold mb-4"
            style={{ color: 'var(--color-accent-6)' }}
          >
            {SITE_INFO.location}
          </p>
          <p
            className="text-lg max-w-2xl mx-auto"
            style={{ color: 'var(--color-subheading)' }}
          >
            Based in Manila, available for remote collaboration and in-person
            meetings in the Philippines.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div
            className="p-8 rounded-xl border-2"
            style={{
              backgroundColor: 'var(--color-card-bg)',
              borderColor: 'var(--color-card-border)',
            }}
          >
            <div className="flex items-start gap-4">
              <Icon
                name="clock"
                size="xl"
                style={{ color: 'var(--color-accent-6)' }}
              />
              <div>
                <h3
                  className="text-xl font-semibold mb-2"
                  style={{ color: 'var(--color-heading)' }}
                >
                  Response Time
                </h3>
                <p style={{ color: 'var(--color-subheading)' }}>
                  I typically respond to emails within 24-48 hours during
                  weekdays.
                </p>
              </div>
            </div>
          </div>

          <div
            className="p-8 rounded-xl border-2"
            style={{
              backgroundColor: 'var(--color-card-bg)',
              borderColor: 'var(--color-card-border)',
            }}
          >
            <div className="flex items-start gap-4">
              <Icon
                name="experience"
                size="xl"
                style={{ color: 'var(--color-accent-6)' }}
              />
              <div>
                <h3
                  className="text-xl font-semibold mb-2"
                  style={{ color: 'var(--color-heading)' }}
                >
                  Best Time to Reach
                </h3>
                <p style={{ color: 'var(--color-subheading)' }}>
                  Email is the best way to reach me. For urgent matters, please
                  call or text.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
